import { httpRequest } from '../../shared/lib/utils/httpClient';
export interface FacilityFilterType {
  healthSystems: HealthSystem[];
}
export interface HealthSystem {
  id: number;
  name: string;
  facilities: Facility[];
}

export interface Facility {
  id: number;
  name: string;
}
export interface IndeterminateCheckboxProps {
  faciltyName: string;
  facility: number;
  checked: boolean;
  hospitals: Hospitals[];
  checkFacility: boolean | null;
  checkInderterminate: boolean;
}

export interface Hospitals {
  id: number;
  checked: boolean;
  name: string;
}

export interface Hospital {
  id: number;
  name: string;
}

export interface ConsultsResponse {
  consultId: number;
  facilityName: string | null;
  patientFirstName: string | null;
  patientLastName: string | null;
  dob: string | null;
  mrn: string | null;
  callBackNumber: string | null;
  unitDepartment: string | null;
  cart: string | null;
  reason: string | null;
  sessionStatus: string | null;
  waitStartTime: string | null;
  waitEndTime: string | null;
  partnerName: string | null;
  providerFirstName: string | null;
  providerLastName: string | null;
  assignedFlag: boolean | null;
  acceptedDateTime: string | null;
  isExternalConsult: boolean | null;
  unreadMessageCount: number;
}

export interface TodaysConsults {
  myConsults: ConsultsResponse[];
  availableConsults: ConsultsResponse[];
  assignedConsults: ConsultsResponse[];
}

export interface PastsConsults {
  myPastConsults: ConsultsResponse[];
  assignedPastConsults: ConsultsResponse[];
}

export interface AcceptResponse {
  code: number;
  status: string;
  message: string;
  providerFirstName: string;
  providerLastName: string;
}

export interface CancelResponse {
  code: number;
  status: string;
  message: string;
}
export const getTodaysConsults = async (
  userId: number
): Promise<TodaysConsults> => {
  const response = await httpRequest<TodaysConsults>({
    url: `/clinical/consult/${userId}/all`,
    method: 'GET',
  });
  return response;
};

export const getPastsConsults = async (
  userId: number
): Promise<PastsConsults> => {
  const response = await httpRequest<PastsConsults>({
    url: `/clinical/consult/${userId}/past`,
    method: 'GET',
  });
  return response;
};

export const getFacilityFilter = async (
  userId: number
): Promise<FacilityFilterType> => {
  const response = await httpRequest<FacilityFilterType>({
    url: `/clinical/consult/health-system?providerId=${userId}`,
    method: 'GET',
  });
  return response;
};

export const acceptAConsult = async (
  userId: number,
  consultId: number
): Promise<AcceptResponse> => {
  const response = await httpRequest<AcceptResponse>({
    url: `/clinical/consult/${consultId}/accept?providerId=${userId}`,
    method: 'PUT',
  });
  return response;
};
